export default __webpack_public_path__ + "static/pitto-03ebc4c2b2e575755dfbc6c33cdd83bf.pdf";